import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { ADD_CLIENT, ADD_CLIENT_SUCCESS, ADD_CLIENT_FAIL, UPDATE_CLIENT, UPDATE_CLIENT_SUCCESS, UPDATE_CLIENT_FAIL } from "./actionType";
import { addNewClientError, addNewClientSuccess, updateClientSuccess, updateClientFail, updateClientsLoading } from './action';
//Include Both Helper File with needed methods
import { postNewClient, clientUpdate } from "../../../helpers/backend_helper";
import "toastr/build/toastr.min.css";
import toast from "react-hot-toast";

// const fireBaseBackend = getFirebaseBackend();

function* newClient({ payload: { user, history, id } }) {
  try {
    const data = {};
    data['clientCode'] = user.clientCode;
    data['name'] = user.name;
    data['address_1'] = user.address_1;
    data['address_2'] = user.address_2;
    data['city'] = user.city;
    data['state'] = user.state;
    data['postalCode'] = user.postalCode;
    data['country'] = user.country;
    data['email'] = user.email;
    data['phone'] = user.phone;
    if (id) {
      data['clientId'] = id
    }
    data['pan'] = user.pan;
    data['tan'] = user.tan;
    data['gst'] = user.gst;
    yield put(updateClientsLoading(true));
    const response = yield call(postNewClient, data);
    if (response.status === 'error') {
      toast.error(response.message)
    } else {
      toast.success(response.message)
      yield put(addNewClientSuccess(response))
      history.push("/clients");
    }
    yield put(updateClientsLoading(false));
  } catch (error) {
    yield put(addNewClientError(error.response.data.message));
    toast.error(error.response.data.message)
  }
}

function* onUpdateClient({ payload: id }) {
  yield put(updateClientsLoading(true));
  try {
    const response = yield call(clientUpdate, id)
    yield put(updateClientSuccess(response.client))
    yield put(updateClientsLoading(false));
  } catch (error) {
    yield put(updateClientsLoading(false));
    yield put(updateClientFail(error))
  }
}

function* newClientSaga() {
  yield takeEvery(ADD_CLIENT, newClient);
  yield takeEvery(UPDATE_CLIENT, onUpdateClient);

}

export default newClientSaga;